import {
  GET_EVENTS_SUCCESS,
  GET_EVENTS_FAIL,
  GET_EVENT_PROFILE_SUCCESS,
  GET_EVENT_PROFILE_FAIL,
  ADD_EVENT_SUCCESS,
  ADD_EVENT_FAIL,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_FAIL,
  DELETE_EVENT_SUCCESS,
  DELETE_EVENT_FAIL,
  DELETE_EVENT,
  ADD_NEW_EVENT,
  UPDATE_EVENT
  
} from "./actionTypes";

const INIT_STATE = {
  events: [],
  eventProfile: {},
  error: {},
  loading: false,
}

const events = (state = INIT_STATE, action) => {
  // console.log(action?.payload)
  switch (action.type) {
    case GET_EVENTS_SUCCESS:
      return {
        ...state,
        events: action.payload.data || [],
        total_page:action.payload.total_page
      }

    case GET_EVENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_NEW_EVENT:
      return {
        ...state,
        loading: true,
      }
    case ADD_EVENT_SUCCESS:
      return {
        ...state,
        // events: [...state.events, action.payload],
        loading: false,
      }

    case ADD_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case UPDATE_EVENT:
      return {
        ...state,
        loading: true,
      }
    case UPDATE_EVENT_SUCCESS:
      return {
        ...state,
        events: state?.events?.map(event =>
          event.id.toString() === action.payload.id.toString()
            ? { ...event, ...action.payload }
            : event
        ),
        loading: false,
      }

    case UPDATE_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case DELETE_EVENT:
      return {
        ...state,
        loading: true,
      }
    case DELETE_EVENT_SUCCESS:
      return {
        ...state,
        events: state?.events?.filter(
          event => event.id.toString() !== action.payload.id.toString()
        ),
        loading: false,
      }

    case DELETE_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case GET_EVENT_PROFILE_SUCCESS:
      return {
        ...state,
        eventProfile: action.payload,
      }

    case GET_EVENT_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
};

export default events;
